import { render, staticRenderFns } from "./MediaArtwork.vue?vue&type=template&id=a899215a"
import script from "./MediaArtwork.vue?vue&type=script&lang=js"
export * from "./MediaArtwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports